import { render } from "./ReverseMortgageDetailModal.vue?vue&type=template&id=67aeadef&scoped=true"
import script from "./ReverseMortgageDetailModal.vue?vue&type=script&lang=js"
export * from "./ReverseMortgageDetailModal.vue?vue&type=script&lang=js"

import "./ReverseMortgageDetailModal.vue?vue&type=style&index=0&id=67aeadef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67aeadef"]])

export default __exports__